<div class="criteria-group" [class.compact]="compact" [class.macro-header-mode]="displayMode === 'macroHeader'">
  <div class="background-wrapper py-2">
    <div class="criteria-items-container">
      <div class="criteria-details">
        <div class="criteria-item">
          <div class="criteria-details">
            <!-- COMMON ID ROW -->
            <div class="id-row" *ngIf="scenarioId">
              <strong class="me-2">{{ displayMode === 'macroHeader' ? 'Macro Scenario ID:' : (displayMode === 'microScenarioSummary' ? 'Micro ID:' : 'Criterion ID:')}}</strong>
              <span>{{ scenarioId }}</span>
              <!-- Ref specific to 'criterion' mode -->
              <div class="d-flex align-items-center gap-2 ms-auto" *ngIf="displayMode === 'criterion' && scenarioRef">
                <span class="small text-muted">(Ref: {{ scenarioRef }})</span>
              </div>
              <!-- Action buttons specific to 'criterion' mode -->
              <div class="d-flex gap-2 ms-auto" *ngIf="displayMode === 'criterion' && criterion">
                <button class="btn btn-sm btn-outline-primary" (click)="openEditModal(editModal)" title="Edit Criterion">
                  <i class="fa fa-pencil"></i>
                </button>
                <button class="btn btn-sm btn-outline-success ml-2" (click)="regenerateTests()" title="Regenerate Tests for Criterion">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>

            <!-- NAME/TITLE/SPECIFICATION ROW -->
            <div class="criteria-row mt-2" *ngIf="scenarioName">
              <span class="criteria-label">
                <ng-container [ngSwitch]="displayMode">
                  <ng-container *ngSwitchCase="'criterion'">Scenario:</ng-container>
                  <ng-container *ngSwitchCase="'microScenarioSummary'">Specification:</ng-container>
                  <ng-container *ngSwitchCase="'macroHeader'">Title:</ng-container>
                  <ng-container *ngSwitchDefault>Details:</ng-container>
                </ng-container>
              </span>
              <div class="criteria-content">
                <strong>{{ scenarioName }}</strong>
              </div>
            </div>

            <!-- NARRATIVE DESCRIPTION - For 'macroHeader' mode -->
            <div class="criteria-section mt-2" *ngIf="displayMode === 'macroHeader' && macroNarrativeDescription">
              <div class="criteria-row">
                <span class="criteria-label">Narrative:</span>
                <div class="criteria-content narrative-description-box">
                    <div *ngFor="let part of macroNarrativeDescription.split('\\n')" class="narrative-paragraph">{{part}}</div>
                </div>
              </div>
            </div>
            
            <!-- TAGS SECTION - Common structure, content varies by mode -->
            <div class="criteria-section mt-2" *ngIf="scenarioTags?.length || (displayMode === 'criterion' && criterion)">
              <div class="criteria-row">
                <span class="criteria-label">Tags:</span>
                <div class="criteria-content tags-section">
                  <ng-container *ngIf="scenarioTags?.length > 0; else noTags">
                    <span class="tag-item" *ngFor="let tag of scenarioTags; let i = index">
                      <span>{{ tag.replace('_', ' ') }}</span>
                      <!-- Remove tag button only for 'criterion' mode -->
                      <i class="fa fa-times-circle delete-icon" 
                         *ngIf="displayMode === 'criterion' && criterion"
                         (click)="removeTag(criterion, i)" title="Remove Tag"></i>
                    </span>
                  </ng-container>
                  <ng-template #noTags>
                    <span class="text-muted fst-italic" *ngIf="displayMode !== 'criterion'">(No tags defined)</span>
                  </ng-template>
                  <!-- Add tag button only for 'criterion' mode -->
                  <button class="btn btn-xs btn-outline-secondary add-tag-btn" 
                          *ngIf="displayMode === 'criterion' && criterion"
                          (click)="openAddTagModal(criterion)" title="Add Tag">
                    <i class="fa fa-plus"></i> Add Tag
                  </button>
                </div>
              </div>
            </div>

            <!-- GHERKIN STEPS - For 'macroHeader' mode -->
            <ng-container *ngIf="displayMode === 'macroHeader' && macroGherkinSteps">
              <div class="gherkin-steps-container mt-2">
                <h6 class="gherkin-title small text-muted">Gherkin Steps:</h6>
                <div class="criteria-section" *ngIf="macroGherkinSteps.given?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">Given</span>
                    <div class="criteria-content gherkin-step">{{ macroGherkinSteps.given[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let condition of macroGherkinSteps.given.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ condition }}</div>
                  </div>
                </div>
                <div class="criteria-section" *ngIf="macroGherkinSteps.when?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">When</span>
                    <div class="criteria-content gherkin-step">{{ macroGherkinSteps.when[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let action of macroGherkinSteps.when.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ action }}</div>
                  </div>
                </div>
                <div class="criteria-section" *ngIf="macroGherkinSteps.then?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">Then</span>
                    <div class="criteria-content gherkin-step">{{ macroGherkinSteps.then[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let result of macroGherkinSteps.then.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ result }}</div>
                  </div>
                </div>
                <div *ngIf="!macroGherkinSteps.given?.length && !macroGherkinSteps.when?.length && !macroGherkinSteps.then?.length" class="text-muted fst-italic small ps-3">
                  (No Gherkin steps defined for this macro scenario)
                </div>
              </div>
            </ng-container>

            <!-- Test Data Elements section - Only for 'criterion' mode -->
            <div class="criteria-section mt-2" *ngIf="displayMode === 'criterion' && criterion?.test_data_elements?.length">
              <div class="criteria-row">
                <span class="criteria-label">Test Data:</span>
                <div class="criteria-content test-data-section">
                  <span class="test-data-item" *ngFor="let dataElement of criterion.test_data_elements; let i = index">
                    <span (dblclick)="openEditTestDataModal(i)" title="Double click to edit '{{getFieldName(dataElement)}}'">
                      {{ getFieldName(dataElement) }}
                    </span>
                    <i class="fa fa-times-circle delete-icon" (click)="removeTestDataElement(i)" title="Remove Test Data"></i>
                  </span>
                  <button class="btn btn-xs btn-outline-secondary add-test-data-btn" (click)="openAddTestDataModal()" title="Add Test Data">
                    <i class="fa fa-plus"></i> Add Test Data
                  </button>
                </div>
              </div>
            </div>

            <!-- Given/When/Then sections for 'criterion' mode (these are specific to AcceptanceCriterion structure) -->
            <ng-container *ngIf="displayMode === 'criterion'">
              <div class="gherkin-steps-container mt-2" *ngIf="criterion?.given?.length || criterion?.when?.length || criterion?.then?.length">
                 <h6 class="gherkin-title small text-muted">Criterion Gherkin:</h6>
                <div class="criteria-section" *ngIf="criterion?.given?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">Given</span>
                    <div class="criteria-content gherkin-step">{{ criterion.given[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let condition of criterion.given.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ condition }}</div>
                  </div>
                </div>
                <div class="criteria-section" *ngIf="criterion?.when?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">When</span>
                    <div class="criteria-content gherkin-step">{{ criterion.when[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let action of criterion.when.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ action }}</div>
                  </div>
                </div>
                <div class="criteria-section" *ngIf="criterion?.then?.length">
                  <div class="criteria-row">
                    <span class="criteria-label gherkin-keyword">Then</span>
                    <div class="criteria-content gherkin-step">{{ criterion.then[0] }}</div>
                  </div>
                  <div class="criteria-row" *ngFor="let result of criterion.then.slice(1)">
                    <span class="criteria-label gherkin-keyword">And</span>
                    <div class="criteria-content gherkin-step">{{ result }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal Template - Guarded by displayMode -->
<ng-template #editModal let-modal>
  <div *ngIf="displayMode === 'criterion' && editingCriterion">
    <div class="modal-header">
      <h4 class="modal-title">Edit Acceptance Criterion</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div class="mb-3"><label class="form-label">Scenario Name</label><input type="text" class="form-control" [(ngModel)]="editingCriterion.name"></div>
      <div class="mb-3">
        <label class="form-label d-block">Tags</label>
        <div class="conditions-container">
          <div *ngFor="let tag of editingCriterion.tags; let i=index; trackBy: trackByIndex" class="d-flex gap-2 mb-2">
            <select class="form-select" [ngModel]="editingCriterion.tags[i]" (ngModelChange)="editingCriterion.tags[i] = $event">
              <optgroup label="Core Tags"><option value="#business_critical">Business Critical</option><option value="#security">Security</option><option value="#api_integration">API Integration</option><option value="#ui">UI</option><option value="#performance">Performance</option><option value="#stateful">Stateful</option><option value="#validation">Validation</option><option value="#async_concurrency">Async/Concurrency</option><option value="#history_of_bugs">History of Bugs</option></optgroup>
            </select>
            <button type="button" class="btn btn-outline-danger" (click)="removeCondition(editingCriterion.tags, i)"><i class="feather icon-trash"></i></button>
          </div>
        </div>
        <div class="mt-2"><button type="button" class="btn btn-outline-secondary" (click)="addCondition(editingCriterion.tags)">Add Tag</button></div>
      </div>
      <div class="mb-3">
        <label class="form-label d-block">Test Data Elements</label>
        <div class="test-data-items">
          <div *ngFor="let dataElement of editingCriterion.test_data_elements; let i = index" class="d-flex gap-2 mb-2 align-items-center">
            <div class="flex-grow-1">{{ getFieldName(dataElement) }}: {{ getTooltipValue(dataElement) }}</div>
            <div class="d-flex gap-2"><button type="button" class="btn btn-sm btn-outline-primary" (click)="openEditTestDataModal(i)"><i class="fa fa-pencil"></i></button><button type="button" class="btn btn-sm btn-outline-danger" (click)="removeTestDataElement(i)"><i class="fa fa-trash"></i></button></div>
          </div>
        </div>
        <div class="mt-2"><button type="button" class="btn btn-outline-secondary" (click)="openAddTestDataModal()">Add Test Data</button></div>
      </div>
      <div class="mb-3">
        <label class="form-label d-block">Given Conditions</label>
        <div class="conditions-container">
          <div *ngFor="let condition of editingCriterion.given; let i=index; trackBy: trackByIndex" class="d-flex gap-2 mb-2">
            <input type="text" class="form-control" [ngModel]="editingCriterion.given[i]" (ngModelChange)="editingCriterion.given[i] = $event">
            <button type="button" class="btn btn-outline-danger" (click)="removeCondition(editingCriterion.given, i)"><i class="feather icon-trash"></i></button>
          </div>
        </div>
        <div class="mt-2"><button type="button" class="btn btn-outline-secondary" (click)="addCondition(editingCriterion.given)">Add Given Condition</button></div>
      </div>
      <div class="mb-3">
        <label class="form-label d-block">When Actions</label>
        <div class="conditions-container">
          <div *ngFor="let action of editingCriterion.when; let i=index; trackBy: trackByIndex" class="d-flex gap-2 mb-2">
            <input type="text" class="form-control" [ngModel]="editingCriterion.when[i]" (ngModelChange)="editingCriterion.when[i] = $event">
            <button type="button" class="btn btn-outline-danger" (click)="removeCondition(editingCriterion.when, i)"><i class="feather icon-trash"></i></button>
          </div>
        </div>
        <div class="mt-2"><button type="button" class="btn btn-outline-secondary" (click)="addCondition(editingCriterion.when)">Add When Action</button></div>
      </div>
      <div class="mb-3">
        <label class="form-label d-block">Then Results</label>
        <div class="conditions-container">
          <div *ngFor="let result of editingCriterion.then; let i=index; trackBy: trackByIndex" class="d-flex gap-2 mb-2">
            <input type="text" class="form-control" [ngModel]="editingCriterion.then[i]" (ngModelChange)="editingCriterion.then[i] = $event">
            <button type="button" class="btn btn-outline-danger" (click)="removeCondition(editingCriterion.then, i)"><i class="feather icon-trash"></i></button>
          </div>
        </div>
        <div class="mt-2"><button type="button" class="btn btn-outline-secondary" (click)="addCondition(editingCriterion.then)">Add Then Result</button></div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveChanges(modal)">Save Changes</button>
    </div>
  </div>
</ng-template>

<!-- Test Data Edit Modal - Guarded by displayMode -->
<ng-template #testDataEditModal let-modal>
  <div *ngIf="displayMode === 'criterion' && editingTestData.currentCriterion">
    <div class="modal-header">
      <h5 class="modal-title">{{ editingTestData.index >= 0 ? 'Edit' : 'Add' }} Test Data</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group mb-3">
        <label for="dataParamFieldSelect">Field Name</label>
        <select *ngIf="editingTestData.index < 0 && availableDataParamFields.length > 0" class="form-control form-select mb-2" id="dataParamFieldSelect" [(ngModel)]="selectedDataParamField" (change)="onDataParamFieldSelected()"><option value="">-- Select a field --</option><option *ngFor="let field of availableDataParamFields" [value]="field">{{ field }}</option></select>
        <div *ngIf="editingTestData.index < 0" class="mt-2"><label>Or enter custom field name:</label><input type="text" class="form-control" [(ngModel)]="editingTestData.fieldName"></div>
        <input *ngIf="editingTestData.index >= 0" type="text" class="form-control" [(ngModel)]="editingTestData.fieldName" [readonly]="true">
      </div>
      <div class="form-group mb-3"><label for="testDataValue">Value/Details</label><textarea class="form-control" id="testDataValue" rows="3" [(ngModel)]="editingTestData.value"></textarea></div>
    </div>
    <div class="modal-footer"><button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button><button type="button" class="btn btn-primary" (click)="saveTestDataChanges(modal)">Save</button></div>
  </div>
</ng-template>
